import React from 'react';
import { ScrollReveal } from './ScrollReveal';
const reviews = [{
  name: 'Kieran Barter',
  text: 'Avy has been an exceptional partner for us over many years, supporting everything from graphic design and web design to full website builds and ongoing design support. His experience, expertise and design eye are outstanding, and the quality of his work consistently exceeds expectations.'
}, {
  name: 'Bansi Dhamecha',
  text: "An easy person to work with, Avy has made my project move so swiftly and works professionally. He is quick to respond to my queries as well. Avy has helped me create a product which I'm very proud of, and I'm encouraged to work on new material and content with him."
}];
export function ReviewsSection() {
  return <section id="reviews" className="py-20 md:py-32 px-5 md:px-10 bg-paper border-b border-rule/60" data-id="element-198">
      <div className="max-w-6xl mx-auto" data-id="element-199">
        <ScrollReveal data-id="element-200">
          <div className="mb-16 md:mb-20 max-w-2xl" data-id="element-201">
            <p className="text-[10px] uppercase tracking-[0.3em] text-gold mb-6 font-medium" data-id="element-202">
              — Client Feedback
            </p>
            <h2 className="font-serif text-3xl md:text-5xl leading-[1.05] tracking-tight text-ink font-light" data-id="element-203">
              Words from those
              <br data-id="element-204" />
              <em className="italic text-gold" data-id="element-205">we've worked with.</em>
            </h2>
          </div>
        </ScrollReveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16" data-id="element-206">
          {reviews.map((review, i) => <ScrollReveal key={i} delay={i * 0.1} data-id="element-207">
              <figure className="border-t border-ink pt-8" data-id="element-208">
                <span className="font-serif text-6xl text-gold leading-none italic block mb-4" data-id="element-209">
                  &ldquo;
                </span>
                <blockquote className="font-serif text-xl md:text-2xl text-ink-soft leading-relaxed font-light italic mb-8" data-id="element-210">
                  {review.text}
                </blockquote>
                <figcaption className="flex items-center gap-4 pt-6 border-t border-rule" data-id="element-211">
                  <div className="w-10 h-10 rounded-full bg-ink text-ivory flex items-center justify-center font-serif text-sm" data-id="element-212">
                    {review.name.charAt(0)}
                  </div>
                  <div data-id="element-213">
                    <p className="font-serif text-base text-ink" data-id="element-214">
                      {review.name}
                    </p>
                    <p className="text-[10px] uppercase tracking-[0.2em] text-ink-mute mt-0.5" data-id="element-215">
                      Verified Client
                    </p>
                  </div>
                </figcaption>
              </figure>
            </ScrollReveal>)}
        </div>
      </div>
    </section>;
}